/*
 * Blog Article — New Blog template
 *
 * Powers the sticky-sidebar Table of Contents and the squiggly scroll
 * progress bar used by sections/main-article-new-blog.liquid.
 *
 * Author contract (preserved from the legacy implementation):
 *   Inside an article body, add `data-blog-toc-handle="some-handle"` and
 *   optional `data-blog-toc-title="Section title"` to any heading you want
 *   listed in the TOC. The handle becomes the anchor id; the title (or the
 *   handle, if title is omitted) becomes the visible TOC label.
 *
 * Also supports a tiny accordion pattern: a button with class .accordion-toggle
 * toggles the visibility of the immediately-following sibling and rotates a
 * descendant .accordion-icon, mirroring the legacy markup.
 *
 * Loaded with `defer`, so DOM is parsed before this script runs.
 */

(function () {
  'use strict';

  function init() {
    initTOC();
    initAccordions();
  }

  function initTOC() {
    var content = document.querySelector('[data-ba-article-content]');
    var tocList = document.querySelector('[data-ba-toc]');
    var tocWrap = document.querySelector('[data-ba-toc-wrap]');
    var progress = document.querySelector('[data-ba-toc-progress]');

    if (!content || !tocList) {
      return;
    }

    var headings = content.querySelectorAll('[data-blog-toc-handle]');

    if (!headings.length) {
      if (tocWrap) {
        tocWrap.setAttribute('data-empty', 'true');
      }
      return;
    }

    var sectionIds = [];

    headings.forEach(function (el) {
      var handle = el.getAttribute('data-blog-toc-handle');
      if (!handle) return;

      if (!el.id) {
        el.id = handle;
      }

      var title = el.getAttribute('data-blog-toc-title') || el.textContent.trim() || handle;

      var li = document.createElement('li');
      li.className = 'ba__toc-item';
      li.setAttribute('data-target', el.id);
      li.setAttribute('role', 'link');
      li.setAttribute('tabindex', '0');
      li.textContent = title;
      tocList.appendChild(li);

      sectionIds.push(el.id);
    });

    if (!sectionIds.length) {
      if (tocWrap) tocWrap.setAttribute('data-empty', 'true');
      return;
    }

    var tocItems = tocList.querySelectorAll('.ba__toc-item');

    if (progress) {
      var updateProgress = function () {
        var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollHeight <= 0) {
          progress.style.height = '0%';
          return;
        }
        var scrolled = window.scrollY || window.pageYOffset || 0;
        var pct = (scrolled / scrollHeight) * 100;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        progress.style.height = (100 - pct) + '%';
      };

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateProgress();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      updateProgress();
    }

    var observerOptions = {
      root: null,
      rootMargin: '-100px 0px -60% 0px',
      threshold: 0
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tocItems.forEach(function (item) {
            item.classList.remove('ba__toc-item--active');
          });
          var match = tocList.querySelector('.ba__toc-item[data-target="' + cssEscape(entry.target.id) + '"]');
          if (match) {
            match.classList.add('ba__toc-item--active');
          }
        }
      });
    }, observerOptions);

    sectionIds.forEach(function (id) {
      var node = document.getElementById(id);
      if (node) observer.observe(node);
    });

    var onActivate = function (e, item) {
      var targetId = item.getAttribute('data-target');
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - 100;
      window.scrollTo({ top: top, behavior: 'smooth' });
    };

    tocItems.forEach(function (item) {
      item.addEventListener('click', function (e) { onActivate(e, item); });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          onActivate(e, item);
        }
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.accordion-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var content = toggle.nextElementSibling;
        if (!content) return;
        var icon = toggle.querySelector('.accordion-icon');
        content.classList.toggle('tw-hidden');
        if (icon) icon.classList.toggle('tw-rotate-180');
      });
    });
  }

  function cssEscape(value) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
      return CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
